import { useLocation } from "react-router-dom";
import { useEffect } from "react";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="container mx-auto px-4 py-24 text-center min-h-[60vh] flex flex-col items-center justify-center">
      <h1 className="text-6xl font-heading font-bold text-foreground mb-4">404</h1>
      <p className="text-xl text-muted-foreground mb-8">Oops! Page not found</p>
      <a href="/" className="inline-flex items-center gap-2 bg-primary text-primary-foreground px-6 py-3 rounded-lg font-medium hover:opacity-90 transition-opacity">
        Return to Home
      </a>
    </div>
  );
};

export default NotFound;
